import React from 'react';

const Analytics = () => {
  return (
    <>
      <h1 style={{ textAlign: 'center' }}>ANALYTICS</h1>
    </>
  );
};

export default Analytics;